"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _ramda = require("ramda");

var _core = require("@react-page/core");

var _DragDropProvider = _interopRequireDefault(require("@react-page/core/lib/components/DragDropProvider"));

var _Decorator = _interopRequireDefault(require("@react-page/core/lib/components/HotKey/Decorator"));

var _Inner = _interopRequireDefault(require("@react-page/core/lib/components/Editable/Inner"));

var _reduxConnect = require("@react-page/core/lib/reduxConnect");

var _BlurGate = _interopRequireDefault(require("./BlurGate"));

var _Trash = _interopRequireDefault(require("../Trash"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var Editable = function Editable(_ref) {
  var id = _ref.id,
      editor = _ref.editor,
      onChange = _ref.onChange;
  var store = editor.store,
      defaultPlugin = editor.defaultPlugin;

  var _useState = (0, _react.useState)(),
      _useState2 = _slicedToArray(_useState, 2),
      unsubscribe = _useState2[0],
      setUnsubscribe = _useState2[1];

  var _useState3 = (0, _react.useState)(),
      _useState4 = _slicedToArray(_useState3, 2),
      previousState = _useState4[0],
      setPreviousState = _useState4[1];

  var _useState5 = (0, _react.useState)(),
      _useState6 = _slicedToArray(_useState5, 2),
      previousSerialized = _useState6[0],
      setPreviousSerialized = _useState6[1];

  (0, _react.useEffect)(function () {
    setUnsubscribe(store.subscribe(function () {
      if (typeof onChange !== 'function') {
        return;
      }

      var state = _core.Selectors.Editable.editable(store.getState(), {
        id: id
      }); // prevent uneeded updates


      var isEqual = (0, _ramda.equals)(state, previousState);

      if (!state || isEqual) {
        return;
      }

      setPreviousState(state);
      var serialized = editor.plugins.serialize(state);
      var serializedEqual = (0, _ramda.equals)(previousSerialized, serialized);

      if (serializedEqual) {
        return;
      }

      setPreviousSerialized(serialized);
      onChange(serialized);
    }));
    return function () {
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, []);
  return (0, _react.useMemo)(function () {
    return /*#__PURE__*/_react["default"].createElement(_reduxConnect.ReduxProvider, {
      store: store
    }, /*#__PURE__*/_react["default"].createElement(_DragDropProvider["default"], null, /*#__PURE__*/_react["default"].createElement(_Decorator["default"], {
      id: id
    }, /*#__PURE__*/_react["default"].createElement(_BlurGate["default"], null, /*#__PURE__*/_react["default"].createElement(_Inner["default"], {
      id: id,
      defaultPlugin: defaultPlugin
    }), /*#__PURE__*/_react["default"].createElement(_Trash["default"], {
      editor: editor
    })))));
  });
};

var _default = Editable;
exports["default"] = _default;